import { actions } from './patientFile/actions'
import { getters } from './patientFile/getters'
import { state } from './patientFile/state'
import { mutations } from './patientFile/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
